import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { Field } from 'redux-form';

import AutosuggestField from 'components/fields/AutosuggestField';

import OrderInformationSectionTitle from '../OrderInformationSectionTitle';

const OrderInformationReferralSourceSelection = ({
  onAddButtonClick,
  change,
  disabled,
  ...otherProps
}) => (
  <Fragment>
    <OrderInformationSectionTitle title="Referral Source" />
    <Field
      key={otherProps['Referral Source'].map(item => item.ID).join(',')}
      id="Referral Source Name"
      name="Referral Source Name"
      component={AutosuggestField}
      placeholder="-Select Referral Source-"
      fullWidth
      renderSuggestionContent={suggestion => suggestion['Name of source']}
      onSuggestionSelected={(suggestion) => {
        change('Referral Source ID', suggestion.ID);
        change('Selected Referral Source Name', suggestion['Name of source']);
        return suggestion['Name of source'];
      }}
      fetchSuggestions={({ value, offset }) => (new Promise((resolve) => {
        if (offset === 0) {
          if (value.length > 0) {
            resolve(otherProps['Referral Source']
              .filter(item => item['Name of source'].toLowerCase()
                .indexOf(value.toLowerCase()) !== -1));
          } else {
            resolve(otherProps['Referral Source']);
          }
        } else {
          resolve([]);
        }
      }))}
      onListAdornmentClick={onAddButtonClick}
      listAdornmentText="Add From List"
      disabled={disabled}
    />
  </Fragment>
);

OrderInformationReferralSourceSelection.propTypes = {
  change: PropTypes.func.isRequired,
  'Referral Source': PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
    'Name of source': PropTypes.string,
  })),
  onAddButtonClick: PropTypes.func,
  disabled: PropTypes.bool,
};

OrderInformationReferralSourceSelection.defaultProps = {
  'Referral Source': [],
  onAddButtonClick: null,
  disabled: false,
};

export default OrderInformationReferralSourceSelection;



// WEBPACK FOOTER //
// ./src/components/workflow/OrderInformation/OrderInformationReferralSource/OrderInformationReferralSourceSelection.js